'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import * as React from 'react';
import { DEFAULT_MODE_STORAGE_KEY, DEFAULT_COLOR_SCHEME_STORAGE_KEY } from "../InitColorSchemeScript/InitColorSchemeScript.js";
import localStorageManager from "./localStorageManager.js";
function noop() {}
export function getSystemMode(mode) {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      return 'dark';
    }
    return 'light';
  }
  return undefined;
}
function processState(state, callback) {
  if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') {
    return callback('light');
  }
  if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') {
    return callback('dark');
  }
  return undefined;
}
export function getColorScheme(state) {
  return processState(state, function (mode) {
    if (mode === 'light') {
      return state.lightColorScheme;
    }
    if (mode === 'dark') {
      return state.darkColorScheme;
    }
    return undefined;
  });
}
export default function useCurrentColorScheme(options) {
  var _options$defaultMode = options.defaultMode,
    defaultMode = _options$defaultMode === void 0 ? 'light' : _options$defaultMode,
    defaultLightColorScheme = options.defaultLightColorScheme,
    defaultDarkColorScheme = options.defaultDarkColorScheme,
    _options$supportedCol = options.supportedColorSchemes,
    supportedColorSchemes = _options$supportedCol === void 0 ? [] : _options$supportedCol,
    _options$modeStorageK = options.modeStorageKey,
    modeStorageKey = _options$modeStorageK === void 0 ? DEFAULT_MODE_STORAGE_KEY : _options$modeStorageK,
    _options$colorSchemeS = options.colorSchemeStorageKey,
    colorSchemeStorageKey = _options$colorSchemeS === void 0 ? DEFAULT_COLOR_SCHEME_STORAGE_KEY : _options$colorSchemeS,
    _options$storageWindo = options.storageWindow,
    storageWindow = _options$storageWindo === void 0 ? typeof window === 'undefined' ? undefined : window : _options$storageWindo,
    _options$storageManag = options.storageManager,
    storageManager = _options$storageManag === void 0 ? localStorageManager : _options$storageManag,
    _options$noSsr = options.noSsr,
    noSsr = _options$noSsr === void 0 ? false : _options$noSsr;
  var joinedColorSchemes = supportedColorSchemes.join(',');
  var isMultiSchemes = supportedColorSchemes.length > 1;
  var modeStorage = React.useMemo(function () {
    return storageManager === null || storageManager === void 0 ? void 0 : storageManager({
      key: modeStorageKey,
      storageWindow: storageWindow
    });
  }, [storageManager, modeStorageKey, storageWindow]);
  var lightStorage = React.useMemo(function () {
    return storageManager === null || storageManager === void 0 ? void 0 : storageManager({
      key: "".concat(colorSchemeStorageKey, "-light"),
      storageWindow: storageWindow
    });
  }, [storageManager, colorSchemeStorageKey, storageWindow]);
  var darkStorage = React.useMemo(function () {
    return storageManager === null || storageManager === void 0 ? void 0 : storageManager({
      key: "".concat(colorSchemeStorageKey, "-dark"),
      storageWindow: storageWindow
    });
  }, [storageManager, colorSchemeStorageKey, storageWindow]);
  var _React$useState = React.useState(function () {
      var initialMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.get(defaultMode)) || defaultMode;
      var lightColorScheme = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.get(defaultLightColorScheme)) || defaultLightColorScheme;
      var darkColorScheme = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.get(defaultDarkColorScheme)) || defaultDarkColorScheme;
      return {
        mode: initialMode,
        systemMode: getSystemMode(initialMode),
        lightColorScheme: lightColorScheme,
        darkColorScheme: darkColorScheme
      };
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var _React$useState3 = React.useState(noSsr || !isMultiSchemes),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isClient = _React$useState4[0],
    setIsClient = _React$useState4[1];
  React.useEffect(function () {
    setIsClient(true); // to rerender the component after hydration
  }, []);
  var colorScheme = getColorScheme(state);
  var setMode = React.useCallback(function (mode) {
    setState(function (currentState) {
      if (mode === currentState.mode) {
        // do nothing if mode does not change
        return currentState;
      }
      var newMode = mode !== null && mode !== void 0 ? mode : defaultMode;
      modeStorage === null || modeStorage === void 0 || modeStorage.set(newMode);
      return _objectSpread(_objectSpread({}, currentState), {}, {
        mode: newMode,
        systemMode: getSystemMode(newMode)
      });
    });
  }, [modeStorage, defaultMode]);
  var setColorScheme = React.useCallback(function (value) {
    if (!value) {
      setState(function (currentState) {
        lightStorage === null || lightStorage === void 0 || lightStorage.set(defaultLightColorScheme);
        darkStorage === null || darkStorage === void 0 || darkStorage.set(defaultDarkColorScheme);
        return _objectSpread(_objectSpread({}, currentState), {}, {
          lightColorScheme: defaultLightColorScheme,
          darkColorScheme: defaultDarkColorScheme
        });
      });
    } else if (typeof value === 'string') {
      if (value && !joinedColorSchemes.includes(value)) {
        console.error("`".concat(value, "` does not exist in `theme.colorSchemes`."));
      } else {
        setState(function (currentState) {
          var newState = _objectSpread({}, currentState);
          processState(currentState, function (mode) {
            if (mode === 'light') {
              lightStorage === null || lightStorage === void 0 || lightStorage.set(value);
              newState.lightColorScheme = value;
            }
            if (mode === 'dark') {
              darkStorage === null || darkStorage === void 0 || darkStorage.set(value);
              newState.darkColorScheme = value;
            }
          });
          return newState;
        });
      }
    } else {
      setState(function (currentState) {
        var newState = _objectSpread({}, currentState);
        var newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
        var newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
        if (newLightColorScheme) {
          if (!joinedColorSchemes.includes(newLightColorScheme)) {
            console.error("`".concat(newLightColorScheme, "` does not exist in `theme.colorSchemes`."));
          } else {
            newState.lightColorScheme = newLightColorScheme;
            lightStorage === null || lightStorage === void 0 || lightStorage.set(newLightColorScheme);
          }
        }
        if (newDarkColorScheme) {
          if (!joinedColorSchemes.includes(newDarkColorScheme)) {
            console.error("`".concat(newDarkColorScheme, "` does not exist in `theme.colorSchemes`."));
          } else {
            newState.darkColorScheme = newDarkColorScheme;
            darkStorage === null || darkStorage === void 0 || darkStorage.set(newDarkColorScheme);
          }
        }
        return newState;
      });
    }
  }, [joinedColorSchemes, lightStorage, darkStorage, defaultLightColorScheme, defaultDarkColorScheme]);
  var handleMediaQuery = React.useCallback(function (event) {
    if (state.mode === 'system') {
      setState(function (currentState) {
        var systemMode = event !== null && event !== void 0 && event.matches ? 'dark' : 'light';

        // Early exit, nothing changed.
        if (currentState.systemMode === systemMode) {
          return currentState;
        }
        return _objectSpread(_objectSpread({}, currentState), {}, {
          systemMode: systemMode
        });
      });
    }
  }, [state.mode]);

  // Ref hack to avoid adding handleMediaQuery as a dep
  var mediaListener = React.useRef(handleMediaQuery);
  mediaListener.current = handleMediaQuery;
  React.useEffect(function () {
    if (typeof window.matchMedia !== 'function' || !isMultiSchemes) {
      return undefined;
    }
    var handler = function handler() {
      return mediaListener.current.apply(mediaListener, arguments);
    };

    // Always listen to System preference
    var media = window.matchMedia('(prefers-color-scheme: dark)');

    // Intentionally use deprecated listener methods to support iOS & old browsers
    media.addListener(handler);
    handler(media);
    return function () {
      media.removeListener(handler);
    };
  }, [isMultiSchemes]);

  // Handle when localStorage has changed
  React.useEffect(function () {
    if (isMultiSchemes) {
      var unsubscribeMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.subscribe(function (value) {
        if (!value || ['light', 'dark', 'system'].includes(value)) {
          setMode(value || defaultMode);
        }
      })) || noop;
      var unsubscribeLight = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.subscribe(function (value) {
        if (!value || joinedColorSchemes.match(value)) {
          setColorScheme({
            light: value
          });
        }
      })) || noop;
      var unsubscribeDark = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.subscribe(function (value) {
        if (!value || joinedColorSchemes.match(value)) {
          setColorScheme({
            dark: value
          });
        }
      })) || noop;
      return function () {
        unsubscribeMode();
        unsubscribeLight();
        unsubscribeDark();
      };
    }
    return undefined;
  }, [setColorScheme, setMode, joinedColorSchemes, defaultMode, storageWindow, isMultiSchemes, modeStorage, lightStorage, darkStorage]);
  return _objectSpread(_objectSpread({}, state), {}, {
    mode: isClient ? state.mode : undefined,
    systemMode: isClient ? state.systemMode : undefined,
    colorScheme: isClient ? colorScheme : undefined,
    setMode: setMode,
    setColorScheme: setColorScheme
  });
}